// features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const savedAuth = JSON.parse(localStorage.getItem("auth"));

const initialState = savedAuth || {
  user: null,
  token: null,
  refreshToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { userData, token, refreshToken } = action.payload;
      state.userData = userData;
      state.token = token;
      state.refreshToken = refreshToken;
      localStorage.setItem(
        "auth",
        JSON.stringify({ userData, token, refreshToken })
      );
    },
    logout: (state) => {
      state.userData = null;
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem("auth");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
